/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_Timing_SyncInputs */



/**
* | output |
* | --- |
* | "Timing & Sync" |
*
* @param {Quicktools_Tab_Timing_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_timing_sync = /** @type {((inputs?: Quicktools_Tab_Timing_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_Timing_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Minutage et synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timing & Synchronisation")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempistica e sincronizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Синхронизация и определение времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización y tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时序与同步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングと同期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय और सिंक्रनाइज़ेशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronização e ajuste de tempo")
	return /** @type {LocalizedString} */ ("Timing & Sync")
});